import { Link } from 'react-router-dom';
import { Navbar } from '@/components/Navbar';
import { Footer } from '@/components/Footer';
import { Button } from '@/components/ui/button';
import { XCircle } from 'lucide-react';

const PaymentCancelPage = () => {
  return (
    <div>
      <Navbar />
      
      <div className="max-w-3xl mx-auto px-6 py-20">
        <div className="glass-card p-12 rounded-lg text-center" data-testid="payment-cancel-card">
          <div className="w-20 h-20 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-12 h-12 text-yellow-600" />
          </div>
          
          <h1 className="text-4xl font-bold mb-4" style={{ fontFamily: 'Cabinet Grotesk' }} data-testid="payment-cancel-title">
            Payment Cancelled
          </h1>
          
          <p className="text-lg text-muted-foreground mb-8" data-testid="payment-cancel-message">
            Your payment was cancelled. No charges were made to your account.
          </p>

          <p className="text-sm text-muted-foreground mb-8">
            If you encountered any issues or have questions, please contact our support team.
          </p>

          <div className="flex gap-4 justify-center">
            <Link to="/cars" data-testid="payment-cancel-browse-btn">
              <Button className="btn-primary">
                Continue Browsing
              </Button>
            </Link>
            <Link to="/dashboard" data-testid="payment-cancel-dashboard-btn">
              <Button variant="outline">
                Go to Dashboard
              </Button>
            </Link>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PaymentCancelPage;
